import Component from '../../../shared/component';

export default class TeacherURLSharings extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.$form = this.$element.find('.teacherURLSharings-form');
    this.$emailsInput = this.$element.find('.teacherURLSharings-form-emails');
    this.$messageInput = this.$element.find('.teacherURLSharings-form-message');
    this.$successAlert = this.$element.find(
      '.teacherURLSharings-form-flash--notice'
    );
    this.$errorAlert = this.$element.find(
      '.teacherURLSharings-form-flash--alert'
    );

    this.bindEvents();
  }

  bindEvents() {
    this.handleSend = this.handleSend.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleError = this.handleError.bind(this);

    this.$form.on('ajax:send.teacherURLSharings', this.handleSend);
    this.$form.on('ajax:success.teacherURLSharings', this.handleSuccess);
    this.$form.on('ajax:error.teacherURLSharings', this.handleError);
  }

  unbindEvents() {
    this.$form.off('ajax:send.teacherURLSharings', this.handleSend);
    this.$form.off('ajax:success.teacherURLSharings', this.handleSuccess);
    this.$form.off('ajax:error.teacherURLSharings', this.handleError);
  }

  handleMessageSend() {
    this.resetAlerts();
    this.$successAlert.removeClass('hidden');
  }

  handleSuccess() {
    this.$successAlert.removeClass('hidden');
    this.resetForm();
  }

  handleError() {
    this.$errorAlert.removeClass('hidden');
  }

  resetForm() {
    this.$emailsInput.val('');
    this.$messageInput.val('');
  }

  resetAlerts() {
    this.$successAlert.addClass('hidden');
    this.$errorAlert.addClass('hidden');
  }

  handleShow() {
    this.resetForm();
    this.resetAlerts();
  }

  handleSend() {
    this.resetAlerts();
  }
}
